import React from 'react';
import CouponForm from './form';
import {addJobItem} from '../../modules/Api';
import {normalizer} from './pipeline';
import {notification} from 'antd';
import history from '../../modules/History';

class AddJob extends React.Component {
    constructor() {
        super();
        var end = new Date();
        end.setHours(23,59,58);
        this.state = {
            data: {
                expiration_date: end
            },
            submitted: false,
            
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = normalizer(values);
        addJobItem(formData, (res) => {
            this.setState({submitted:false});
            if(res.id) {
                notification.open({
                    message: `فرصت شغلی با موفقیت اضافه شد!`,
                    description: `فرصت شغلی ثبت شد. می توانید آن را در لیست فرصت های شغلی مشاهده کنید و در صورت نیاز ویرایش کنید.`
                });
                history.item.push(`/jobs`);
            }
            else{
                notification.open({
                    message: 'خطایی رخ داده است.',
                    description: res.message
                });
            }
        });
    }
    render() {
        return (<div><CouponForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddJob;


// WEBPACK FOOTER //
// ./src/containers/Jobs/add.js